import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // ← Cette ligne DOIT être là !
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const environment = process.env.REACT_APP_ENV || process.env.NODE_ENV;

if (environment === 'prod') {
    // 🔇 Désactiver les logs en production
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.warn = () => {};
    // Garder console.error pour les vraies erreurs

    console.error('🎯 Application démarrée en mode PRODUCTION - Logs désactivés');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();